/* ============================================
   FIELD FLEX — SHOPIFY THEME JS
   ============================================ */

document.addEventListener('DOMContentLoaded', function() {
  initMobileMenu();
  initParticles();
  initProductTabs();
  initCartDrawer();
  initEmailPopup();
  initModals();
  initVariantSelector();
  initCollectionFilters();
  initQuantitySelector();
  initGallery();
  initStickyATC();
  initSlideshow();
  initTestimonialsCarousel();
  initMegaMenu();
  initPredictiveSearch();
  initImageZoom();
  initQuickView();
  initRecentlyViewed();
  initCartUpsells();
  initProductCardHover();
  initCountdown();
  initBeforeAfter();
  initScrollingText();
  initRelatedProducts();
  initScrollAnimations();
  initBackToTop();
  initBackInStock();
  initWishlist();
  initReviewForm();
  initReviewStarPicker();
  initProductDropTimer();
  initCardDropTimers();
});

/* === MOBILE MENU === */
function initMobileMenu() {
  var toggle = document.querySelector('.mobile-toggle');
  var nav = document.querySelector('.header-nav');
  if (!toggle || !nav) return;
  toggle.addEventListener('click', function() {
    toggle.classList.toggle('active');
    nav.classList.toggle('open');
    var isOpen = nav.classList.contains('open');
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });
}

/* === PARTICLES === */
function initParticles() {
  var container = document.getElementById('particles');
  if (!container) return;
  for (var i = 0; i < 30; i++) {
    var p = document.createElement('div');
    p.className = 'particle';
    p.style.left = Math.random() * 100 + '%';
    p.style.animationDuration = (4 + Math.random() * 6) + 's';
    p.style.animationDelay = (Math.random() * 8) + 's';
    var size = 2 + Math.random() * 3;
    p.style.width = size + 'px';
    p.style.height = size + 'px';
    p.style.opacity = 0.3 + Math.random() * 0.5;
    container.appendChild(p);
  }
}

/* === PRODUCT TABS === */
function initProductTabs() {
  var btns = document.querySelectorAll('.product-tabs__btn');
  var panels = document.querySelectorAll('.product-tabs__panel');
  if (!btns.length) return;
  btns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var target = btn.dataset.tab;
      btns.forEach(function(b) { b.classList.remove('active'); });
      panels.forEach(function(p) { p.classList.remove('active'); });
      btn.classList.add('active');
      var panel = document.getElementById(target);
      if (panel) panel.classList.add('active');
    });
  });
}

/* === CART DRAWER === */
function initCartDrawer() {
  var openBtns = document.querySelectorAll('[data-cart-open]');
  var drawer = document.querySelector('.cart-drawer');
  var overlay = document.querySelector('.cart-drawer-overlay');
  var closeBtn = document.querySelector('.cart-drawer__close');
  if (!drawer) return;

  function openCart() {
    drawer.classList.add('active');
    if (overlay) overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    // Refresh upsells when cart drawer opens
    if (typeof loadCartUpsells === 'function') loadCartUpsells();
  }
  function closeCart() {
    drawer.classList.remove('active');
    if (overlay) overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  openBtns.forEach(function(btn) { btn.addEventListener('click', openCart); });
  if (closeBtn) closeBtn.addEventListener('click', closeCart);
  if (overlay) overlay.addEventListener('click', closeCart);
}

/* === EMAIL POPUP === */
function initEmailPopup() {
  var popup = document.querySelector('.email-popup-overlay');
  if (!popup) return;

  var closeBtn = popup.querySelector('.email-popup__close');
  var dismissLink = popup.querySelector('.email-popup__dismiss-link');
  var delay = parseInt(popup.dataset.delay || '5') * 1000;
  var triggerMode = popup.dataset.triggerMode || 'delay';
  var dismissDays = parseInt(popup.dataset.dismissDays || '7');
  var hasShown = false;

  // Check if already dismissed this session
  if (sessionStorage.getItem('ff_popup_dismissed')) return;

  // Check if already submitted
  if (localStorage.getItem('ff_popup_submitted')) return;

  // Check localStorage dismissal with expiry
  var dismissedUntil = localStorage.getItem('ff_popup_dismissed_until');
  if (dismissedUntil && Date.now() < parseInt(dismissedUntil)) return;

  function showPopup() {
    if (hasShown) return;
    hasShown = true;
    popup.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closePopup() {
    popup.classList.remove('active');
    document.body.style.overflow = '';
    sessionStorage.setItem('ff_popup_dismissed', 'true');
    if (dismissDays > 0) {
      var expiresAt = Date.now() + (dismissDays * 24 * 60 * 60 * 1000);
      localStorage.setItem('ff_popup_dismissed_until', expiresAt.toString());
    }
  }

  // --- Delay trigger ---
  if (triggerMode === 'delay' || triggerMode === 'both') {
    setTimeout(showPopup, delay);
  }

  // --- Exit intent trigger ---
  if (triggerMode === 'exit_intent' || triggerMode === 'both') {
    // Desktop: mouse leaves viewport toward top
    document.addEventListener('mouseleave', function(e) {
      if (e.clientY < 10) showPopup();
    });

    // Mobile: scroll-up-after-scrolling-down pattern
    var maxScrollPercent = 0;
    var lastScrollY = 0;
    var mobileTriggered = false;
    var isMobile = window.innerWidth < 1024;

    if (isMobile) {
      window.addEventListener('scroll', function() {
        if (hasShown || mobileTriggered) return;

        var scrollY = window.pageYOffset || document.documentElement.scrollTop;
        var docHeight = document.documentElement.scrollHeight - window.innerHeight;
        var currentPercent = docHeight > 0 ? (scrollY / docHeight) * 100 : 0;

        // Track max scroll depth
        if (currentPercent > maxScrollPercent) {
          maxScrollPercent = currentPercent;
        }

        // Detect quick upward scroll after reaching 40%+ depth
        if (maxScrollPercent >= 40 && scrollY < lastScrollY) {
          var scrollUpDelta = lastScrollY - scrollY;
          if (scrollUpDelta > 80) {
            mobileTriggered = true;
            showPopup();
          }
        }

        lastScrollY = scrollY;
      }, { passive: true });
    }
  }

  // --- Close handlers ---
  if (closeBtn) closeBtn.addEventListener('click', closePopup);
  if (dismissLink) dismissLink.addEventListener('click', closePopup);

  // Click outside to dismiss
  popup.addEventListener('click', function(e) {
    if (e.target === popup) closePopup();
  });

  // ESC key to dismiss
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && popup.classList.contains('active')) {
      closePopup();
    }
  });

  // Mark as submitted on form submit
  var form = popup.querySelector('form');
  if (form) {
    form.addEventListener('submit', function() {
      localStorage.setItem('ff_popup_submitted', 'true');
      sessionStorage.setItem('ff_popup_dismissed', 'true');
    });
  }
}

/* === MODALS === */
function initModals() {
  var triggers = document.querySelectorAll('[data-modal]');
  triggers.forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      var modal = document.querySelector(trigger.dataset.modal);
      if (modal) {
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
    });
  });

  document.querySelectorAll('.modal__close, .modal-overlay').forEach(function(el) {
    el.addEventListener('click', function(e) {
      if (e.target === el) {
        var overlay = el.closest('.modal-overlay') || el.parentElement.closest('.modal-overlay');
        if (overlay) {
          overlay.classList.remove('active');
          document.body.style.overflow = '';
        }
      }
    });
  });
}

/* === VARIANT SELECTOR === */
function initVariantSelector() {
  var options = document.querySelectorAll('.variant-option:not(.sold-out)');
  options.forEach(function(opt) {
    opt.addEventListener('click', function() {
      var group = opt.closest('.variant-options');
      group.querySelectorAll('.variant-option').forEach(function(o) { o.classList.remove('active'); });
      opt.classList.add('active');

      // Update hidden variant input
      updateSelectedVariant();
    });
  });
}

function updateSelectedVariant() {
  var form = document.querySelector('.product-form');
  if (!form) return;
  var selected = form.querySelectorAll('.variant-option.active');
  var values = [];
  selected.forEach(function(s) { values.push(s.dataset.value); });

  // Find matching variant from JSON
  var variantData = form.dataset.variants;
  if (!variantData) return;
  var variants = JSON.parse(variantData);
  var match = variants.find(function(v) {
    return v.options.every(function(opt, i) { return opt === values[i]; });
  });

  if (match) {
    var idInput = form.querySelector('[name="id"]');
    if (idInput) idInput.value = match.id;

    // Update price
    var priceEl = document.querySelector('.product-info__price');
    if (priceEl) {
      priceEl.textContent = '$' + (match.price / 100).toFixed(2);
    }

    // Update add to cart button
    var addBtn = form.querySelector('.add-to-cart-btn');
    if (addBtn) {
      if (match.available) {
        addBtn.disabled = false;
        addBtn.textContent = 'ADD TO CART';
      } else {
        addBtn.disabled = true;
        addBtn.textContent = 'SOLD OUT';
      }
    }

    // Update gallery image
    if (match.featured_image) {
      var mainImg = document.querySelector('.product-gallery__main img');
      if (mainImg) mainImg.src = match.featured_image.src;
    }

    // Toggle notify-me button visibility
    var notifyBtn = document.querySelector('.notify-me-btn');
    if (notifyBtn) {
      notifyBtn.style.display = match.available ? 'none' : '';
    }

    // Update notify modal hidden fields
    var notifyTags = document.querySelector('[data-notify-tags]');
    var notifyBody = document.querySelector('[data-notify-body]');
    if (notifyTags) notifyTags.value = 'back-in-stock,' + (window.__productHandle || '') + ',' + match.title;
    if (notifyBody) notifyBody.value = 'Back in stock request for: ' + match.title + ' (' + (window.__productHandle || '') + ')';

    // Sync sticky add-to-cart bar
    if (typeof syncStickyATC === 'function') syncStickyATC();
  }
}

/* === QUANTITY SELECTOR === */
function initQuantitySelector() {
  var selectors = document.querySelectorAll('.quantity-selector');
  selectors.forEach(function(sel) {
    var minus = sel.querySelector('[data-qty="minus"]');
    var plus = sel.querySelector('[data-qty="plus"]');
    var input = sel.querySelector('.quantity-input');
    if (!minus || !plus || !input) return;

    minus.addEventListener('click', function() {
      var val = parseInt(input.value) || 1;
      if (val > 1) input.value = val - 1;
    });
    plus.addEventListener('click', function() {
      var val = parseInt(input.value) || 1;
      input.value = val + 1;
    });
  });
}

/* === PRODUCT GALLERY === */
function initGallery() {
  var thumbs = document.querySelectorAll('.product-gallery__thumb');
  var mainImg = document.querySelector('.product-gallery__main img');
  if (!thumbs.length || !mainImg) return;

  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      thumbs.forEach(function(t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      var newSrc = thumb.getAttribute('data-image');
      if (newSrc) {
        mainImg.src = newSrc;
        mainImg.srcset = newSrc + ' 900w';
      }
      var zoomSrc = thumb.getAttribute('data-zoom-src');
      if (zoomSrc) {
        mainImg.setAttribute('data-zoom-src', zoomSrc);
      }
    });
  });
}

/* === AJAX ADD TO CART === */
document.addEventListener('submit', function(e) {
  if (!e.target.matches('.product-form')) return;
  e.preventDefault();

  var form = e.target;
  var btn = form.querySelector('.add-to-cart-btn');
  var originalText = btn.textContent;
  btn.textContent = 'ADDING...';
  btn.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: form.querySelector('[name="id"]').value,
      quantity: parseInt(form.querySelector('.quantity-input').value) || 1
    })
  })
  .then(function(res) { return res.json(); })
  .then(function(data) {
    btn.textContent = 'ADDED ✓';
    updateCartCount();

    // Show toast notification
    showToast('Added to Cart', data.product_title || data.title || 'Item added successfully', 'success');

    // Open cart drawer
    var drawer = document.querySelector('.cart-drawer');
    var overlay = document.querySelector('.cart-drawer-overlay');
    if (drawer) drawer.classList.add('active');
    if (overlay) overlay.classList.add('active');

    setTimeout(function() {
      btn.textContent = originalText;
      btn.disabled = false;
    }, 1500);

    refreshCartDrawer();
  })
  .catch(function() {
    btn.textContent = 'ERROR';
    showToast('Error', 'Could not add item to cart', 'error');
    setTimeout(function() {
      btn.textContent = originalText;
      btn.disabled = false;
    }, 1500);
  });
});

function updateCartCount() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var counts = document.querySelectorAll('.cart-count');
      counts.forEach(function(c) {
        c.textContent = cart.item_count;
        c.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    });
}

function refreshCartDrawer() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var itemsContainer = document.querySelector('.cart-drawer__items');
      var totalEl = document.querySelector('.cart-drawer__total-price');
      if (!itemsContainer) return;

      if (cart.items.length === 0) {
        itemsContainer.innerHTML = '<p style="text-align:center;color:var(--color-muted);padding:40px 0;">Your cart is empty</p>';
        if (totalEl) totalEl.textContent = '$0.00';
        return;
      }

      var html = '';
      cart.items.forEach(function(item) {
        html += '<div class="cart-item">';
        html += '  <div class="cart-item__image"><img src="' + item.image + '" alt="' + item.title + '"></div>';
        html += '  <div>';
        html += '    <div class="cart-item__title">' + item.product_title + '</div>';
        html += '    <div class="cart-item__variant">' + item.variant_title + ' × ' + item.quantity + '</div>';
        html += '    <div class="cart-item__bottom">';
        html += '      <span class="cart-item__price">$' + (item.final_line_price / 100).toFixed(2) + '</span>';
        html += '      <a href="/cart/change?id=' + item.key + '&quantity=0" class="cart-item__remove" onclick="event.preventDefault();removeCartItem(\'' + item.key + '\')">Remove</a>';
        html += '    </div>';
        html += '  </div>';
        html += '</div>';
      });
      itemsContainer.innerHTML = html;
      if (totalEl) totalEl.textContent = '$' + (cart.total_price / 100).toFixed(2);
    });
}

/* === STICKY ADD TO CART === */
function initStickyATC() {
  var stickyBar = document.getElementById('stickyATC');
  var addBtn = document.querySelector('.add-to-cart-btn');
  if (!stickyBar || !addBtn) return;

  // Hide sticky ATC if drop timer is active
  var dropTimer = document.querySelector('[data-product-drop]');
  if (dropTimer) {
    stickyBar.style.display = 'none';
    return;
  }

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        stickyBar.classList.remove('visible');
        stickyBar.setAttribute('aria-hidden', 'true');
      } else {
        stickyBar.classList.add('visible');
        stickyBar.setAttribute('aria-hidden', 'false');
      }
    });
  }, { threshold: 0 });

  observer.observe(addBtn);

  // Sticky bar button does its own AJAX add-to-cart using the main form's data
  var stickyBtn = document.getElementById('stickyATCBtn');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function() {
      if (stickyBtn.disabled) return;
      var form = document.querySelector('.product-form');
      if (!form) return;

      var variantId = form.querySelector('[name="id"]').value;
      var qtyInput = form.querySelector('.quantity-input');
      var quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
      var originalText = stickyBtn.textContent;

      stickyBtn.textContent = 'ADDING...';
      stickyBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: quantity })
      })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        stickyBtn.textContent = 'ADDED \u2713';
        updateCartCount();
        showToast('Added to Cart', data.product_title || data.title || 'Item added successfully', 'success');

        var drawer = document.querySelector('.cart-drawer');
        var overlay = document.querySelector('.cart-drawer-overlay');
        if (drawer) drawer.classList.add('active');
        if (overlay) overlay.classList.add('active');

        setTimeout(function() {
          stickyBtn.textContent = originalText;
          stickyBtn.disabled = false;
        }, 1500);

        refreshCartDrawer();
      })
      .catch(function() {
        stickyBtn.textContent = 'ERROR';
        showToast('Error', 'Could not add item to cart', 'error');
        setTimeout(function() {
          stickyBtn.textContent = originalText;
          stickyBtn.disabled = false;
        }, 1500);
      });
    });
  }

}

function syncStickyATC() {
  var form = document.querySelector('.product-form');
  var stickyBtn = document.getElementById('stickyATCBtn');
  var stickyPrice = document.querySelector('[data-sticky-price]');
  var stickyCompare = document.querySelector('[data-sticky-compare-price]');
  var stickyImage = document.getElementById('stickyATCImage');
  if (!form || !stickyBtn) return;

  var variantData = form.dataset.variants;
  if (!variantData) return;

  var idInput = form.querySelector('[name="id"]');
  if (!idInput) return;
  var currentId = parseInt(idInput.value);

  var variants = JSON.parse(variantData);
  var match = variants.find(function(v) { return v.id === currentId; });
  if (!match) return;

  // Update price
  if (stickyPrice) {
    stickyPrice.textContent = Shopify.formatMoney ? Shopify.formatMoney(match.price) : ('$' + (match.price / 100).toFixed(2));
  }

  // Update compare-at price
  if (stickyCompare) {
    if (match.compare_at_price && match.compare_at_price > match.price) {
      stickyCompare.textContent = Shopify.formatMoney ? Shopify.formatMoney(match.compare_at_price) : ('$' + (match.compare_at_price / 100).toFixed(2));
      stickyCompare.style.display = '';
    } else {
      stickyCompare.style.display = 'none';
    }
  }

  // Update image if variant has a featured image
  if (stickyImage && match.featured_image) {
    stickyImage.src = match.featured_image.src.replace(/(\.\w+)\?/, function(m, ext) { return ext + '?'; }).replace(/&width=\d+/, '') + '&width=80';
  }

  // Update button state
  if (match.available) {
    stickyBtn.disabled = false;
    stickyBtn.textContent = 'ADD TO CART';
  } else {
    stickyBtn.disabled = true;
    stickyBtn.textContent = 'SOLD OUT';
  }
}

function removeCartItem(key) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  })
  .then(function() {
    updateCartCount();
    refreshCartDrawer();
    setTimeout(function() { loadCartUpsells(); }, 400);
  });
}

/* === SLIDESHOW === */
function initSlideshow() {
  var containers = document.querySelectorAll('[data-slideshow]');
  containers.forEach(function(container) {
    var slides = container.querySelectorAll('.slideshow__slide');
    var dots = container.querySelectorAll('.slideshow__dot');
    var prevBtn = container.querySelector('.slideshow__prev');
    var nextBtn = container.querySelector('.slideshow__next');
    if (slides.length < 2) return;

    var current = 0;
    var autoplay = container.dataset.autoplay === 'true';
    var speed = (parseInt(container.dataset.speed) || 5) * 1000;
    var timer;

    function goTo(index) {
      slides[current].classList.remove('active');
      if (dots[current]) dots[current].classList.remove('active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('active');
      if (dots[current]) dots[current].classList.add('active');
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      if (autoplay) timer = setInterval(next, speed);
    }
    function stopAutoplay() { clearInterval(timer); }

    if (nextBtn) nextBtn.addEventListener('click', function() { stopAutoplay(); next(); startAutoplay(); });
    if (prevBtn) prevBtn.addEventListener('click', function() { stopAutoplay(); prev(); startAutoplay(); });
    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        stopAutoplay();
        goTo(parseInt(dot.dataset.slide));
        startAutoplay();
      });
    });

    startAutoplay();
  });
}

/* === TESTIMONIALS CAROUSEL === */
function initTestimonialsCarousel() {
  var carousels = document.querySelectorAll('[data-testimonials-carousel]');
  carousels.forEach(function(carousel) {
    var track = carousel.querySelector('.testimonials__track');
    var prevBtn = carousel.querySelector('.testimonials__prev');
    var nextBtn = carousel.querySelector('.testimonials__next');
    var cards = carousel.querySelectorAll('.testimonial-card');
    if (!track || cards.length < 2) return;

    var current = 0;

    function goTo(index) {
      current = Math.max(0, Math.min(index, cards.length - 1));
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
    }

    if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });
    if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
  });
}

/* ============================================
   PHASE 3 — NAVIGATION & PRODUCT EXPERIENCE
   ============================================ */

/* === MEGA MENU === */
function initMegaMenu() {
  var triggers = document.querySelectorAll('[data-mega-trigger]');
  var closeDelay = 250;

  triggers.forEach(function(trigger) {
    var menu = trigger.querySelector('[data-mega-menu]');
    var link = trigger.querySelector('[data-mega-link]');
    if (!menu) return;
    var closeTimer = null;

    function openMenu() {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      /* Close other open menus first */
      triggers.forEach(function(other) {
        if (other !== trigger && other.classList.contains('active')) {
          other.classList.remove('active');
          var otherLink = other.querySelector('[data-mega-link]');
          if (otherLink) otherLink.setAttribute('aria-expanded', 'false');
        }
      });
      trigger.classList.add('active');
      if (link) link.setAttribute('aria-expanded', 'true');
    }

    function closeMenu() {
      trigger.classList.remove('active');
      if (link) link.setAttribute('aria-expanded', 'false');
    }

    /* Desktop: hover with delay */
    trigger.addEventListener('mouseenter', function() {
      if (window.innerWidth > 768) openMenu();
    });
    trigger.addEventListener('mouseleave', function() {
      if (window.innerWidth > 768) {
        closeTimer = setTimeout(closeMenu, closeDelay);
      }
    });

    /* Mobile: click/tap to toggle accordion */
    if (link) {
      link.addEventListener('click', function(e) {
        if (window.innerWidth <= 768) {
          e.preventDefault();
          if (trigger.classList.contains('active')) {
            closeMenu();
          } else {
            openMenu();
          }
        }
      });
    }

    /* Keyboard navigation */
    if (link) {
      link.addEventListener('keydown', function(e) {
        var key = e.key;
        if (key === 'Enter' || key === ' ') {
          e.preventDefault();
          if (trigger.classList.contains('active')) {
            closeMenu();
            link.focus();
          } else {
            openMenu();
            /* Focus first link inside menu */
            var firstChild = menu.querySelector('.mega-menu__link, .mega-menu__heading--link');
            if (firstChild) firstChild.focus();
          }
        }
        if (key === 'ArrowDown') {
          e.preventDefault();
          if (!trigger.classList.contains('active')) openMenu();
          var firstChild = menu.querySelector('.mega-menu__link, .mega-menu__heading--link');
          if (firstChild) firstChild.focus();
        }
        if (key === 'Escape') {
          closeMenu();
          link.focus();
        }
      });
    }

    /* Arrow key navigation within mega menu */
    menu.addEventListener('keydown', function(e) {
      var focusable = menu.querySelectorAll('.mega-menu__link, .mega-menu__heading--link');
      if (!focusable.length) return;
      var current = Array.prototype.indexOf.call(focusable, document.activeElement);

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        var next = (current + 1) % focusable.length;
        focusable[next].focus();
      }
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        var prev = current <= 0 ? focusable.length - 1 : current - 1;
        focusable[prev].focus();
      }
      if (e.key === 'Escape') {
        e.preventDefault();
        closeMenu();
        if (link) link.focus();
      }
      if (e.key === 'Tab' && !e.shiftKey && current === focusable.length - 1) {
        closeMenu();
      }
    });
  });
}

/* === PREDICTIVE SEARCH === */
function initPredictiveSearch() {
  var searchOpen = document.querySelector('[data-search-open]');
  var searchOverlay = document.querySelector('[data-predictive-search]');
  var searchClose = document.querySelector('[data-search-close]');
  var searchInput = document.querySelector('[data-predictive-input]');
  var searchResults = document.querySelector('[data-predictive-results]');
  if (!searchOpen || !searchOverlay) return;

  var debounceTimer;
  var activeIndex = -1;
  var currentQuery = '';
  var isOpen = false;

  function openSearch() {
    searchOverlay.style.display = 'block';
    requestAnimationFrame(function() {
      searchOverlay.classList.add('is-active');
    });
    isOpen = true;
    document.body.style.overflow = 'hidden';
    setTimeout(function() { searchInput.focus(); }, 150);
  }

  function closeSearch() {
    searchOverlay.classList.remove('is-active');
    isOpen = false;
    document.body.style.overflow = '';
    activeIndex = -1;
    currentQuery = '';
    setTimeout(function() {
      searchOverlay.style.display = 'none';
      searchInput.value = '';
      searchResults.innerHTML = '';
    }, 300);
  }

  function setActiveItem(index) {
    var items = searchResults.querySelectorAll('.predictive-search__item');
    if (!items.length) return;
    items.forEach(function(item) { item.classList.remove('is-selected'); });
    if (index < 0) index = items.length - 1;
    if (index >= items.length) index = 0;
    activeIndex = index;
    items[activeIndex].classList.add('is-selected');
    items[activeIndex].scrollIntoView({ block: 'nearest' });
  }

  function showLoading() {
    searchResults.innerHTML = '<div class="predictive-search__loading"><span class="predictive-search__spinner"></span> Searching...</div>';
  }

  function renderResults(data, query) {
    var html = '';
    var products = data.resources.results.products || [];
    var collections = data.resources.results.collections || [];
    var pages = data.resources.results.pages || [];
    var articles = data.resources.results.articles || [];
    var totalResults = products.length + collections.length + pages.length + articles.length;

    if (totalResults === 0) {
      html = '<div class="predictive-search__empty">';
      html += '<svg class="predictive-search__empty-icon" viewBox="0 0 24 24" width="40" height="40"><circle cx="11" cy="11" r="8" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M21 21l-4.35-4.35" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
      html += '<p>No results found for "<strong>' + escapeHtml(query) + '</strong>"</p>';
      html += '<span>Try checking your spelling or using different keywords</span>';
      html += '</div>';
      searchResults.innerHTML = html;
      return;
    }

    if (products.length > 0) {
      html += '<div class="predictive-search__group">';
      html += '<div class="predictive-search__group-heading">Products</div>';
      products.forEach(function(p) {
        var img = p.image ? '<img src="' + p.image + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '';
        var priceHtml = '<span class="predictive-search__item-price">' + formatMoney(p.price) + '</span>';
        if (p.compare_at_price && p.compare_at_price > p.price) {
          priceHtml += '<span class="predictive-search__item-compare">' + formatMoney(p.compare_at_price) + '</span>';
        }
        html += '<a href="' + p.url + '" class="predictive-search__item" data-search-item>';
        html += '<div class="predictive-search__item-image">' + img + '</div>';
        html += '<div class="predictive-search__item-info">';
        html += '<div class="predictive-search__item-title">' + highlightMatch(p.title, query) + '</div>';
        html += '<div class="predictive-search__item-meta">' + priceHtml + '</div>';
        html += '</div></a>';
      });
      html += '</div>';
    }

    if (collections.length > 0) {
      html += '<div class="predictive-search__group">';
      html += '<div class="predictive-search__group-heading">Collections</div>';
      collections.forEach(function(c) {
        html += '<a href="' + c.url + '" class="predictive-search__item" data-search-item>';
        html += '<div class="predictive-search__item-icon"><svg viewBox="0 0 24 24" width="20" height="20"><rect x="3" y="3" width="7" height="7" rx="1" fill="none" stroke="currentColor" stroke-width="1.5"/><rect x="14" y="3" width="7" height="7" rx="1" fill="none" stroke="currentColor" stroke-width="1.5"/><rect x="3" y="14" width="7" height="7" rx="1" fill="none" stroke="currentColor" stroke-width="1.5"/><rect x="14" y="14" width="7" height="7" rx="1" fill="none" stroke="currentColor" stroke-width="1.5"/></svg></div>';
        html += '<div class="predictive-search__item-info">';
        html += '<div class="predictive-search__item-title">' + highlightMatch(c.title, query) + '</div>';
        html += '<div class="predictive-search__item-type">Collection</div>';
        html += '</div></a>';
      });
      html += '</div>';
    }

    if (pages.length > 0) {
      html += '<div class="predictive-search__group">';
      html += '<div class="predictive-search__group-heading">Pages</div>';
      pages.forEach(function(pg) {
        html += '<a href="' + pg.url + '" class="predictive-search__item" data-search-item>';
        html += '<div class="predictive-search__item-icon"><svg viewBox="0 0 24 24" width="20" height="20"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" fill="none" stroke="currentColor" stroke-width="1.5"/><polyline points="14 2 14 8 20 8" fill="none" stroke="currentColor" stroke-width="1.5"/></svg></div>';
        html += '<div class="predictive-search__item-info">';
        html += '<div class="predictive-search__item-title">' + highlightMatch(pg.title, query) + '</div>';
        html += '<div class="predictive-search__item-type">Page</div>';
        html += '</div></a>';
      });
      html += '</div>';
    }

    if (articles.length > 0) {
      html += '<div class="predictive-search__group">';
      html += '<div class="predictive-search__group-heading">Articles</div>';
      articles.forEach(function(a) {
        html += '<a href="' + a.url + '" class="predictive-search__item" data-search-item>';
        html += '<div class="predictive-search__item-icon"><svg viewBox="0 0 24 24" width="20" height="20"><path d="M12 20h9" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" fill="none" stroke="currentColor" stroke-width="1.5"/></svg></div>';
        html += '<div class="predictive-search__item-info">';
        html += '<div class="predictive-search__item-title">' + highlightMatch(a.title, query) + '</div>';
        html += '<div class="predictive-search__item-type">Article</div>';
        html += '</div></a>';
      });
      html += '</div>';
    }

    html += '<a href="/search?q=' + encodeURIComponent(query) + '" class="predictive-search__view-all" data-search-item>';
    html += 'View all results for "<strong>' + escapeHtml(query) + '</strong>"';
    html += '<svg viewBox="0 0 24 24" width="16" height="16"><path d="M5 12h14" fill="none" stroke="currentColor" stroke-width="2"/><path d="M12 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2"/></svg>';
    html += '</a>';

    searchResults.innerHTML = html;
    activeIndex = -1;
  }

  function highlightMatch(text, query) {
    if (!query) return escapeHtml(text);
    var escaped = escapeHtml(text);
    var regex = new RegExp('(' + escapeRegex(query) + ')', 'gi');
    return escaped.replace(regex, '<mark>$1</mark>');
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  function escapeRegex(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  searchOpen.addEventListener('click', function(e) {
    e.preventDefault();
    openSearch();
  });

  if (searchClose) {
    searchClose.addEventListener('click', closeSearch);
  }

  // Close on overlay background click
  searchOverlay.addEventListener('click', function(e) {
    if (e.target === searchOverlay) closeSearch();
  });

  // Keyboard navigation
  searchInput.addEventListener('keydown', function(e) {
    var items = searchResults.querySelectorAll('[data-search-item]');

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      if (items.length) setActiveItem(activeIndex + 1);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (items.length) setActiveItem(activeIndex - 1);
    } else if (e.key === 'Enter') {
      if (activeIndex >= 0 && items[activeIndex]) {
        e.preventDefault();
        items[activeIndex].click();
      }
    } else if (e.key === 'Escape') {
      e.preventDefault();
      closeSearch();
    }
  });

  // Debounced search input
  searchInput.addEventListener('input', function() {
    clearTimeout(debounceTimer);
    var query = searchInput.value.trim();
    currentQuery = query;

    if (query.length < 2) {
      searchResults.innerHTML = '';
      activeIndex = -1;
      return;
    }

    showLoading();

    debounceTimer = setTimeout(function() {
      var fetchQuery = currentQuery;
      fetch('/search/suggest.json?q=' + encodeURIComponent(fetchQuery) + '&resources[type]=product,collection,page,article&resources[limit]=4')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          // Only render if the query hasn't changed while fetching
          if (fetchQuery === currentQuery) {
            renderResults(data, fetchQuery);
          }
        })
        .catch(function() {
          if (fetchQuery === currentQuery) {
            searchResults.innerHTML = '<div class="predictive-search__empty"><p>Error loading results. Please try again.</p></div>';
          }
        });
    }, 300);
  });
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

/* === IMAGE ZOOM === */
function initImageZoom() {
  /* Skip on touch devices */
  var isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
  if (isTouch) return;

  var zoomContainers = document.querySelectorAll('[data-image-zoom]');
  zoomContainers.forEach(function(container) {
    var img = container.querySelector('img');
    if (!img) return;

    container.addEventListener('mouseenter', function() {
      container.classList.add('zoomed');
    });

    container.addEventListener('mousemove', function(e) {
      if (!container.classList.contains('zoomed')) return;
      var rect = container.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      img.style.transformOrigin = x + '% ' + y + '%';
    });

    container.addEventListener('mouseleave', function() {
      container.classList.remove('zoomed');
      img.style.transformOrigin = 'center center';
    });
  });
}

/* === QUICK VIEW === */
function initQuickView() {
  var overlay = document.querySelector('[data-quick-view-overlay]');
  if (!overlay) return;

  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-quick-view-trigger]');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();

    var handle = trigger.getAttribute('data-quick-view-trigger');
    if (!handle) return;

    fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(product) {
        populateQuickView(overlay, product);
        overlay.style.display = 'flex';
      })
      .catch(function(err) { console.error('Quick view error:', err); });
  });

  // Close
  var closeBtn = overlay.querySelector('[data-quick-view-close]');
  if (closeBtn) closeBtn.addEventListener('click', function() { overlay.style.display = 'none'; });
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) overlay.style.display = 'none';
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.style.display === 'flex') overlay.style.display = 'none';
  });
}

function populateQuickView(overlay, product) {
  var img = overlay.querySelector('[data-quick-view-image]');
  var title = overlay.querySelector('[data-quick-view-title]');
  var price = overlay.querySelector('[data-quick-view-price]');
  var vendor = overlay.querySelector('[data-quick-view-vendor]');
  var link = overlay.querySelector('[data-quick-view-link]');
  var variantId = overlay.querySelector('[data-quick-view-variant-id]');
  var optionsContainer = overlay.querySelector('[data-quick-view-options]');
  var form = overlay.querySelector('[data-quick-view-form]');

  if (img && product.featured_image) {
    img.src = product.featured_image;
    img.alt = product.title;
  }
  if (title) title.textContent = product.title;
  if (price) price.textContent = formatMoney(product.price);
  if (vendor) vendor.textContent = product.vendor;
  if (link) link.href = '/products/' + product.handle;
  if (variantId && product.variants.length > 0) variantId.value = product.variants[0].id;

  // Build options
  if (optionsContainer) {
    var html = '';
    product.options.forEach(function(option, i) {
      var optionName = (typeof option === 'string') ? option : (option.name || option);
      html += '<div class="variant-selector"><span class="variant-selector__label">' + optionName + '</span>';
      html += '<div class="variant-options">';
      var values = [];
      product.variants.forEach(function(v) {
        var val = v.options[i];
        if (values.indexOf(val) === -1) {
          values.push(val);
          var isFirst = values.length === 1;
          html += '<button type="button" class="variant-option' + (isFirst ? ' active' : '') + '" data-value="' + val + '">' + val + '</button>';
        }
      });
      html += '</div></div>';
    });
    optionsContainer.innerHTML = html;

    // Variant selection in quick view
    optionsContainer.addEventListener('click', function(e) {
      var btn = e.target.closest('.variant-option');
      if (!btn) return;
      var group = btn.closest('.variant-options');
      group.querySelectorAll('.variant-option').forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');

      // Find matching variant
      var selected = [];
      optionsContainer.querySelectorAll('.variant-options').forEach(function(g) {
        var activeBtn = g.querySelector('.variant-option.active');
        if (activeBtn) selected.push(activeBtn.getAttribute('data-value'));
      });

      var match = product.variants.find(function(v) {
        return v.options.every(function(opt, idx) { return opt === selected[idx]; });
      });

      if (match) {
        variantId.value = match.id;
        price.textContent = formatMoney(match.price);
      }
    });
  }

  // ATC form
  if (form) {
    form.onsubmit = function(e) {
      e.preventDefault();
      var id = variantId.value;
      var qty = form.querySelector('.quantity-input');
      var quantity = qty ? parseInt(qty.value) : 1;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(id), quantity: quantity })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        overlay.style.display = 'none';
        if (typeof openCartDrawer === 'function') openCartDrawer();
        else window.location.href = '/cart';
      })
      .catch(function(err) { console.error('Add to cart error:', err); });
    };
  }
}

/* === RECENTLY VIEWED === */
function initRecentlyViewed() {
  var section = document.querySelector('[data-recently-viewed]');
  if (!section) return;

  var grid = section.querySelector('[data-recently-viewed-grid]');
  if (!grid) return;

  var key = 'field-flex-recently-viewed';
  var handles = [];
  try { handles = JSON.parse(localStorage.getItem(key)) || []; } catch(e) {}

  // Exclude current product if on a product page
  var currentHandle = window.location.pathname.match(/\/products\/([^/?]+)/);
  if (currentHandle) {
    handles = handles.filter(function(h) { return h !== currentHandle[1]; });
  }

  var maxAttr = section.getAttribute('data-max') || '4';
  var max = parseInt(maxAttr) || 4;
  handles = handles.slice(0, max);

  if (handles.length === 0) {
    section.style.display = 'none';
    return;
  }

  var fetches = handles.map(function(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function(r) { if (r.ok) return r.json(); return null; })
      .catch(function() { return null; });
  });

  Promise.all(fetches).then(function(products) {
    var html = '';
    products.forEach(function(p) {
      if (!p) return;
      var imgSrc = p.featured_image || '';
      html += '<div class="product-card"><a href="/products/' + p.handle + '">';
      html += '<div class="product-card__image">';
      if (imgSrc) html += '<img src="' + imgSrc + '" alt="' + p.title + '" loading="lazy" width="600" height="600">';
      html += '</div>';
      html += '<div class="product-card__info">';
      html += '<h3 class="product-card__title">' + p.title + '</h3>';
      html += '<div class="product-card__price">' + formatMoney(p.price) + '</div>';
      html += '</div></a></div>';
    });
    grid.innerHTML = html;
  });
}

/* === CART UPSELLS === */
var _upsellCache = {};

function initCartUpsells() {
  var upsellGrid = document.querySelector('[data-cart-upsell-grid]');
  if (!upsellGrid) return;
  loadCartUpsells();
}

function loadCartUpsells() {
  var upsellGrid = document.querySelector('[data-cart-upsell-grid]');
  var upsellSection = document.querySelector('[data-cart-upsells]');
  if (!upsellGrid || !upsellSection) return;

  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      if (!cart.items || cart.items.length === 0) {
        upsellSection.style.display = 'none';
        return;
      }
      upsellSection.style.display = '';

      // Use the most recently added item (last in array) for recommendations
      var basisProductId = cart.items[cart.items.length - 1].product_id;

      // Collect all product IDs currently in cart to exclude them
      var cartProductIds = {};
      cart.items.forEach(function(item) {
        cartProductIds[item.product_id] = true;
      });

      // Show loading skeletons while fetching
      showUpsellSkeletons(upsellGrid);

      // Return cached results if available
      if (_upsellCache[basisProductId]) {
        renderUpsellCards(upsellGrid, _upsellCache[basisProductId], cartProductIds);
        return;
      }

      // Fetch from Shopify Product Recommendations API
      fetch('/recommendations/products.json?product_id=' + basisProductId + '&limit=8')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var products = data.products || [];
          _upsellCache[basisProductId] = products;
          renderUpsellCards(upsellGrid, products, cartProductIds);
        })
        .catch(function() {
          upsellSection.style.display = 'none';
        });
    });
}

function showUpsellSkeletons(grid) {
  var html = '';
  for (var i = 0; i < 2; i++) {
    html += '<div class="cart-upsell-skeleton">';
    html += '<div class="cart-upsell-skeleton__image"></div>';
    html += '<div class="cart-upsell-skeleton__lines">';
    html += '<div class="cart-upsell-skeleton__line" style="width:' + (60 + i * 10) + '%"></div>';
    html += '<div class="cart-upsell-skeleton__line" style="width:' + (35 + i * 5) + '%"></div>';
    html += '</div></div>';
  }
  grid.innerHTML = html;
}

function renderUpsellCards(grid, products, cartProductIds) {
  var filtered = products.filter(function(p) {
    return !cartProductIds[p.id];
  });

  var upsellSection = document.querySelector('[data-cart-upsells]');
  if (filtered.length === 0) {
    if (upsellSection) upsellSection.style.display = 'none';
    return;
  }

  var toShow = filtered.slice(0, 4);
  var html = '';
  toShow.forEach(function(p) {
    var img = p.featured_image || '';
    var price = formatMoney(p.price);
    var compareHtml = '';
    if (p.compare_at_price && p.compare_at_price > p.price) {
      compareHtml = '<span class="cart-upsell-item__compare">' + formatMoney(p.compare_at_price) + '</span>';
    }
    var variantId = (p.variants && p.variants.length > 0) ? p.variants[0].id : p.id;

    html += '<div class="cart-upsell-item">';
    html += '  <a href="' + p.url + '" class="cart-upsell-item__image">';
    if (img) html += '<img src="' + img + '" alt="' + p.title + '" loading="lazy" width="60" height="60">';
    html += '  </a>';
    html += '  <div class="cart-upsell-item__info">';
    html += '    <a href="' + p.url + '" class="cart-upsell-item__title">' + p.title + '</a>';
    html += '    <div class="cart-upsell-item__prices">' + price + compareHtml + '</div>';
    html += '  </div>';
    html += '  <button class="cart-upsell-item__add" data-upsell-add data-variant-id="' + variantId + '" aria-label="Add ' + p.title + ' to cart">ADD</button>';
    html += '</div>';
  });
  grid.innerHTML = html;

  // Bind ADD buttons
  grid.querySelectorAll('[data-upsell-add]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      btn.textContent = '...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        btn.textContent = '\u2713';
        updateCartCount();
        refreshCartDrawer();
        // Reload upsells after drawer refreshes to re-filter
        setTimeout(function() { loadCartUpsells(); }, 600);
      })
      .catch(function() {
        btn.textContent = 'ERR';
        setTimeout(function() {
          btn.textContent = 'ADD';
          btn.disabled = false;
        }, 1500);
      });
    });
  });
}

/* === PRODUCT CARD HOVER (Image Swap) === */
function initProductCardHover() {
  var cards = document.querySelectorAll('.product-card__image img[data-hover-src]');
  cards.forEach(function(img) {
    var originalSrc = img.src;
    var hoverSrc = img.getAttribute('data-hover-src');
    if (!hoverSrc) return;

    // Preload hover image
    var preload = new Image();
    preload.src = hoverSrc;

    img.closest('.product-card__image').addEventListener('mouseenter', function() {
      img.src = hoverSrc;
    });
    img.closest('.product-card__image').addEventListener('mouseleave', function() {
      img.src = originalSrc;
    });
  });
}

/* === COUNTDOWN TIMER === */
function initCountdown() {
  var timers = document.querySelectorAll('[data-countdown]');
  timers.forEach(function(el) {
    var target = new Date(el.getAttribute('data-target')).getTime();
    var daysEl = el.querySelector('[data-countdown-days]');
    var hoursEl = el.querySelector('[data-countdown-hours]');
    var minsEl = el.querySelector('[data-countdown-mins]');
    var secsEl = el.querySelector('[data-countdown-secs]');
    var expiredEl = el.parentElement.querySelector('[data-countdown-expired]');

    function pad(n) { return n < 10 ? '0' + n : n; }

    function unlockDrop() {
      var section = el.closest('.countdown-section') || el.parentElement;
      var unlockEls = section.querySelectorAll('[data-countdown-unlock]');
      unlockEls.forEach(function(u) { u.style.display = ''; });
      var lockEls = section.querySelectorAll('[data-countdown-lock]');
      lockEls.forEach(function(l) { l.style.display = 'none'; });
      var atcBtns = section.querySelectorAll('[data-countdown-add-to-cart]');
      atcBtns.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          var variantId = btn.getAttribute('data-variant-id');
          btn.disabled = true;
          btn.textContent = 'ADDING...';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
          })
          .then(function(r) { return r.json(); })
          .then(function() {
            btn.textContent = 'ADDED';
            setTimeout(function() { btn.textContent = 'ADD TO CART'; btn.disabled = false; }, 2000);
            fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
              document.querySelectorAll('.cart-count').forEach(function(c) {
                c.textContent = cart.item_count;
                c.style.display = cart.item_count > 0 ? 'flex' : 'none';
              });
            });
          })
          .catch(function() { btn.textContent = 'ERROR'; btn.disabled = false; });
        });
      });
    }

    function tick() {
      var now = Date.now();
      var diff = target - now;
      if (diff <= 0) {
        el.style.display = 'none';
        if (expiredEl) expiredEl.style.display = '';
        unlockDrop();
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      daysEl.textContent = pad(d);
      hoursEl.textContent = pad(h);
      minsEl.textContent = pad(m);
      secsEl.textContent = pad(s);
    }

    tick();
    setInterval(tick, 1000);
  });
}

/* === BEFORE / AFTER SLIDER === */
function initBeforeAfter() {
  var sliders = document.querySelectorAll('[data-before-after]');
  sliders.forEach(function(slider) {
    var wrapper = slider.querySelector('.before-after__wrapper');
    var overlay = slider.querySelector('[data-before-after-overlay]');
    var handle = slider.querySelector('[data-before-after-handle]');
    if (!wrapper || !overlay || !handle) return;

    var isDragging = false;

    function setPosition(x) {
      var rect = wrapper.getBoundingClientRect();
      var pct = Math.max(0, Math.min(1, (x - rect.left) / rect.width));
      overlay.style.width = (pct * 100) + '%';
      handle.style.left = (pct * 100) + '%';
    }

    function onStart(e) {
      isDragging = true;
      e.preventDefault();
      var x = e.touches ? e.touches[0].clientX : e.clientX;
      setPosition(x);
    }
    function onMove(e) {
      if (!isDragging) return;
      var x = e.touches ? e.touches[0].clientX : e.clientX;
      setPosition(x);
    }
    function onEnd() { isDragging = false; }

    wrapper.addEventListener('mousedown', onStart);
    wrapper.addEventListener('touchstart', onStart, { passive: false });
    document.addEventListener('mousemove', onMove);
    document.addEventListener('touchmove', onMove, { passive: true });
    document.addEventListener('mouseup', onEnd);
    document.addEventListener('touchend', onEnd);
  });
}

/* === SCROLLING TEXT / MARQUEE === */
function initScrollingText() {
  var sections = document.querySelectorAll('[data-scrolling-text]');
  sections.forEach(function(el) {
    var track = el.querySelector('.scrolling-text__track');
    if (!track) return;
    var speed = el.getAttribute('data-speed') || 20;
    var direction = el.getAttribute('data-direction') || 'left';
    track.style.animationDuration = speed + 's';
    if (direction === 'right') {
      track.setAttribute('data-direction', 'right');
      track.style.animationDirection = 'reverse';
    }
  });
}

/* === SCROLL ANIMATIONS (IntersectionObserver) === */
function initScrollAnimations() {
  var elements = document.querySelectorAll('[data-animate]');
  if (!elements.length) return;

  // Set stagger indices on children
  var staggerParents = document.querySelectorAll('[data-animate-stagger]');
  staggerParents.forEach(function(parent) {
    var children = parent.querySelectorAll('[data-animate]');
    children.forEach(function(child, i) {
      child.style.setProperty('--stagger-index', i);
    });
  });

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        // Add a small delay so the transition is visible
        var delay = entry.target.getAttribute('data-animate-delay');
        if (delay) {
          entry.target.style.transitionDelay = delay + 'ms';
        }
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -40px 0px'
  });

  elements.forEach(function(el) { observer.observe(el); });
}

/* === BACK TO TOP === */
function initBackToTop() {
  var btn = document.querySelector('.back-to-top');
  if (!btn) return;

  var scrollThreshold = 600;

  function checkScroll() {
    if (window.scrollY > scrollThreshold) {
      btn.classList.add('visible');
    } else {
      btn.classList.remove('visible');
    }
  }

  var ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        checkScroll();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  btn.addEventListener('click', function() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  checkScroll();
}

/* === TOAST NOTIFICATIONS === */
function showToast(title, message, type) {
  var container = document.querySelector('.toast-container');
  if (!container) return;

  type = type || 'success';

  var toast = document.createElement('div');
  toast.className = 'toast toast--' + type;
  toast.style.position = 'relative';

  var iconSvg = type === 'success'
    ? '<svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>'
    : '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/></svg>';

  toast.innerHTML =
    '<div class="toast__icon">' + iconSvg + '</div>' +
    '<div class="toast__text"><strong>' + title + '</strong><span>' + message + '</span></div>' +
    '<button class="toast__close" aria-label="Close"><svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>' +
    '<div class="toast__progress"></div>';

  container.appendChild(toast);

  // Trigger entrance
  requestAnimationFrame(function() {
    requestAnimationFrame(function() {
      toast.classList.add('toast--visible');
    });
  });

  // Close button
  toast.querySelector('.toast__close').addEventListener('click', function() {
    dismissToast(toast);
  });

  // Auto dismiss after 3.5s
  setTimeout(function() { dismissToast(toast); }, 3500);
}

/* === ESC KEY — CLOSE MODALS & DRAWERS === */
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    // Close cart drawer
    var cartDrawer = document.querySelector('.cart-drawer.active');
    var cartOverlay = document.querySelector('.cart-drawer-overlay.active');
    if (cartDrawer) {
      cartDrawer.classList.remove('active');
      if (cartOverlay) cartOverlay.classList.remove('active');
      document.body.style.overflow = '';
    }
    // Close search overlay (handled by initPredictiveSearch keydown listener)
    // Close quick view
    var quickView = document.querySelector('[data-quick-view-overlay]');
    if (quickView && quickView.style.display === 'flex') {
      quickView.style.display = 'none';
    }
    // Close email popup
    var popup = document.querySelector('.email-popup-overlay.active');
    if (popup) {
      popup.classList.remove('active');
      document.body.style.overflow = '';
      sessionStorage.setItem('ff_popup_dismissed', 'true');
    }
    // Close mobile menu
    var mobileNav = document.querySelector('.header-nav.open');
    if (mobileNav) {
      mobileNav.classList.remove('open');
      var toggle = document.querySelector('.mobile-toggle');
      if (toggle) {
        toggle.classList.remove('active');
        toggle.setAttribute('aria-expanded', 'false');
      }
    }
  }
});

function dismissToast(toast) {
  if (toast.classList.contains('toast--exit')) return;
  toast.classList.remove('toast--visible');
  toast.classList.add('toast--exit');
  setTimeout(function() {
    if (toast.parentNode) toast.parentNode.removeChild(toast);
  }, 400);
}

/* === RELATED PRODUCTS (Shopify Recommendations API) === */
function initRelatedProducts() {
  var grid = document.querySelector('[data-related-products]');
  if (!grid) return;
  // Only fetch if the grid is empty (no Liquid-rendered items)
  if (grid.children.length > 0) return;
  var productId = grid.getAttribute('data-product-id');
  var limit = grid.getAttribute('data-limit') || 4;
  if (!productId) return;

  fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + limit)
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (!data.products || data.products.length === 0) {
        grid.closest('.related-products-section').style.display = 'none';
        return;
      }
      var html = '';
      data.products.forEach(function(p) {
        var img = p.featured_image || '';
        var price = formatMoney(p.price);
        var compareHtml = '';
        if (p.compare_at_price && p.compare_at_price > p.price) {
          compareHtml = '<span class="compare-price">' + formatMoney(p.compare_at_price) + '</span>';
        }
        html += '<div class="product-card">';
        html += '<a href="' + p.url + '">';
        html += '<div class="product-card__image">';
        if (img) html += '<img src="' + img + '" alt="' + p.title + '" loading="lazy" width="600" height="600">';
        html += '</div>';
        html += '<div class="product-card__info">';
        html += '<h3 class="product-card__title">' + p.title + '</h3>';
        html += '<div class="product-card__price">' + price + compareHtml + '</div>';
        html += '</div></a></div>';
      });
      grid.innerHTML = html;
    })
    .catch(function() {});
}

/* ============================================
   COLLECTION FILTERS
   ============================================ */
function initCollectionFilters() {
  /* --- Desktop dropdown toggle --- */
  var dropdowns = document.querySelectorAll('[data-cf-dropdown]');
  if (!dropdowns.length) return;

  /* Close all dropdowns */
  function closeAllDropdowns(except) {
    dropdowns.forEach(function(dd) {
      if (dd !== except) dd.classList.remove('is-open');
    });
  }

  /* Close on outside click */
  document.addEventListener('click', function(e) {
    if (!e.target.closest('[data-cf-dropdown]')) {
      closeAllDropdowns();
    }
  });

  /* Close on Escape */
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeAllDropdowns();
      /* Also close mobile drawer */
      var drawer = document.querySelector('.cf-drawer');
      if (drawer && drawer.classList.contains('is-open')) {
        drawer.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    }
  });

  /* --- Price range form submission --- */
  var priceForms = document.querySelectorAll('.cf-price-form');
  priceForms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var inputs = form.querySelectorAll('.cf-price-field__input');
      var params = new URLSearchParams(window.location.search);

      inputs.forEach(function(input) {
        var name = input.getAttribute('name');
        var value = input.value.trim();
        if (name) {
          if (value) {
            /* Shopify expects price in cents (or subunit) */
            var cents = Math.round(parseFloat(value) * 100);
            params.set(name, cents);
          } else {
            params.delete(name);
          }
        }
      });

      var base = window.location.pathname;
      var qs = params.toString();
      window.location.href = base + (qs ? '?' + qs : '');
    });
  });

  /* --- Mobile drawer overlay sync --- */
  var drawer = document.querySelector('.cf-drawer');
  var overlay = document.querySelector('.cf-drawer-overlay');
  if (drawer && overlay) {
    /* Show overlay when drawer opens */
    var observer = new MutationObserver(function() {
      if (drawer.classList.contains('is-open')) {
        overlay.style.display = 'block';
      } else {
        overlay.style.display = 'none';
      }
    });
    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });

    overlay.addEventListener('click', function() {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }
}

/* ============================================
   BACK-IN-STOCK NOTIFICATIONS
   ============================================ */
function initBackInStock() {
  var form = document.querySelector('[data-notify-form]');
  if (!form) return;

  // Set initial notify modal fields from product handle
  var handle = window.__productHandle || '';
  if (handle) {
    var notifyTags = form.querySelector('[data-notify-tags]');
    var notifyBody = form.querySelector('[data-notify-body]');
    if (notifyTags && notifyTags.value === 'back-in-stock') {
      notifyTags.value = 'back-in-stock,' + handle;
    }
    if (notifyBody && !notifyBody.value) {
      notifyBody.value = 'Back in stock request for: ' + handle;
    }
  }

  // Open notify modal from notify-me-btn (uses existing modal system via data-modal)
  // Also handle card-level notify buttons (Hall of Fame)
  document.addEventListener('click', function(e) {
    var cardBtn = e.target.closest('[data-notify-card]');
    if (cardBtn) {
      e.preventDefault();
      var cardHandle = cardBtn.dataset.notifyCard;
      var tags = form.querySelector('[data-notify-tags]');
      var body = form.querySelector('[data-notify-body]');
      if (tags) tags.value = 'back-in-stock,' + cardHandle;
      if (body) body.value = 'Back in stock request for: ' + cardHandle;

      var modal = document.getElementById('notifyModal');
      if (modal) {
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
    }
  });

  // Intercept form submission
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var originalText = btn.textContent;
    btn.textContent = 'SENDING...';
    btn.disabled = true;

    fetch('/contact', {
      method: 'POST',
      body: new FormData(form),
    }).then(function() {
      var modal = form.closest('.modal-overlay');
      if (modal) {
        modal.classList.remove('active');
        document.body.style.overflow = '';
      }
      form.reset();
      showToast('Notification Set', "We'll email you when this is back in stock.", 'success');
    }).catch(function() {
      showToast('Error', 'Something went wrong. Please try again.', 'error');
    }).finally(function() {
      btn.textContent = originalText;
      btn.disabled = false;
    });
  });
}

/* ============================================
   WISHLIST (localStorage)
   ============================================ */
var WISHLIST_KEY = 'field-flex-wishlist';

function getWishlist() {
  try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch(e) { return []; }
}

function saveWishlist(list) {
  try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch(e) {}
}

function toggleWishlist(handle) {
  var list = getWishlist();
  var idx = list.indexOf(handle);
  if (idx > -1) {
    list.splice(idx, 1);
    showToast('Removed', 'Item removed from wishlist', 'success');
  } else {
    list.push(handle);
    showToast('Added to Wishlist', 'Item saved to your wishlist', 'success');
  }
  saveWishlist(list);
  updateWishlistUI();
}

function updateWishlistUI() {
  var list = getWishlist();

  // Update count badges
  document.querySelectorAll('.wishlist-count').forEach(function(el) {
    el.textContent = list.length;
    el.style.display = list.length > 0 ? 'flex' : 'none';
  });

  // Update heart states
  document.querySelectorAll('[data-wishlist-toggle]').forEach(function(btn) {
    var handle = btn.dataset.wishlistToggle;
    btn.classList.toggle('is-active', list.indexOf(handle) > -1);
  });

  // Update product page button text
  var pdpBtn = document.querySelector('.wishlist-add-btn');
  if (pdpBtn) {
    var h = pdpBtn.dataset.wishlistToggle;
    var inList = list.indexOf(h) > -1;
    var svg = pdpBtn.querySelector('svg');
    var svgHtml = svg ? svg.outerHTML : '';
    pdpBtn.innerHTML = svgHtml + (inList ? ' IN YOUR WISHLIST' : ' ADD TO WISHLIST');
  }
}

function initWishlist() {
  // Delegated click handler
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      toggleWishlist(btn.dataset.wishlistToggle);
    }
  });

  updateWishlistUI();

  // Render wishlist page if present
  var grid = document.querySelector('[data-wishlist-grid]');
  var emptyState = document.querySelector('[data-wishlist-empty]');
  if (!grid) return;

  var handles = getWishlist();
  if (handles.length === 0) {
    emptyState.style.display = 'block';
    return;
  }

  var promises = handles.map(function(handle) {
    return fetch('/products/' + handle + '.json')
      .then(function(r) { return r.ok ? r.json() : null; })
      .catch(function() { return null; });
  });

  Promise.all(promises).then(function(results) {
    var html = '';
    results.forEach(function(data) {
      if (!data || !data.product) return;
      html += buildWishlistCard(data.product);
    });
    if (html === '') {
      emptyState.style.display = 'block';
    } else {
      grid.innerHTML = html;
      updateWishlistUI();
    }
  });
}

function buildWishlistCard(p) {
  var img = p.image ? p.image.src : (p.images && p.images.length > 0 ? p.images[0].src : '');
  // Shopify product JSON API returns price as string like "74.88", not cents
  var priceNum = parseFloat(p.variants[0].price);
  var price = '$' + priceNum.toFixed(2);
  var compareHtml = '';
  var comparePrice = parseFloat(p.variants[0].compare_at_price);
  if (comparePrice && comparePrice > priceNum) {
    compareHtml = ' <span class="compare-price">$' + comparePrice.toFixed(2) + '</span>';
  }
  var card = '<div class="product-card">';
  card += '<a href="/products/' + p.handle + '">';
  card += '<div class="product-card__image">';
  if (img) card += '<img src="' + img + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy" style="width:100%;height:100%;object-fit:cover;">';
  card += '</div>';
  card += '<div class="product-card__info">';
  card += '<h3 class="product-card__title">' + p.title + '</h3>';
  card += '<div class="product-card__price">' + price + compareHtml + '</div>';
  card += '</div></a>';
  card += '<button class="wishlist-toggle is-active" data-wishlist-toggle="' + p.handle + '" aria-label="Remove from wishlist" type="button" style="position:absolute;top:12px;right:12px;z-index:3;">';
  card += '<svg viewBox="0 0 24 24" class="wishlist-toggle__icon"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
  card += '</button>';
  card += '</div>';
  return card;
}

/* ============================================
   NATIVE REVIEWS
   ============================================ */
function initReviewForm() {
  var toggleBtn = document.querySelector('[data-toggle-review-form]');
  var wrapper = document.querySelector('[data-review-form-wrapper]');
  if (!toggleBtn || !wrapper) return;

  toggleBtn.addEventListener('click', function() {
    var isHidden = wrapper.style.display === 'none' || wrapper.style.display === '';
    wrapper.style.display = isHidden ? 'block' : 'none';
    if (isHidden) wrapper.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  });

  var form = document.querySelector('[data-review-form]');
  if (!form) return;

  form.addEventListener('submit', function(e) {
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var originalText = btn.textContent;
    btn.textContent = 'SUBMITTING...';
    btn.disabled = true;

    fetch('/contact', {
      method: 'POST',
      body: new FormData(form),
    }).then(function() {
      form.reset();
      wrapper.style.display = 'none';
      // Reset star picker to 5
      var starValue = form.querySelector('[data-star-value]');
      if (starValue) starValue.value = '5';
      var stars = form.querySelectorAll('.star-picker__star');
      stars.forEach(function(s) { s.classList.add('active'); });
      showToast('Review Submitted', 'Thanks! Your review will appear after moderation.', 'success');
    }).catch(function() {
      showToast('Error', 'Could not submit review. Please try again.', 'error');
    }).finally(function() {
      btn.textContent = originalText;
      btn.disabled = false;
    });
  });
}

function initReviewStarPicker() {
  var picker = document.querySelector('[data-star-picker]');
  if (!picker) return;

  var stars = picker.querySelectorAll('.star-picker__star');
  var valueInput = picker.querySelector('[data-star-value]');

  stars.forEach(function(star) {
    star.addEventListener('click', function() {
      var val = parseInt(star.dataset.star);
      if (valueInput) valueInput.value = val;
      stars.forEach(function(s) {
        s.classList.toggle('active', parseInt(s.dataset.star) <= val);
      });
    });

    star.addEventListener('mouseenter', function() {
      var val = parseInt(star.dataset.star);
      stars.forEach(function(s) {
        s.classList.toggle('hover', parseInt(s.dataset.star) <= val);
      });
    });

    star.addEventListener('mouseleave', function() {
      stars.forEach(function(s) { s.classList.remove('hover'); });
    });
  });
}

/* === CARD DROP TIMERS (collection grids) === */
function initCardDropTimers() {
  var cards = document.querySelectorAll('[data-card-drop]');
  cards.forEach(function(el) {
    var target = new Date(el.getAttribute('data-card-drop-target')).getTime();
    var display = el.querySelector('[data-card-drop-display]');
    var atcBtn = el.parentElement.querySelector('[data-card-drop-atc]');

    function pad(n) { return n < 10 ? '0' + n : n; }

    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        el.style.display = 'none';
        if (atcBtn) atcBtn.style.display = '';
        return;
      }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor((diff % 86400000) / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (d > 0) {
        display.textContent = d + 'D ' + pad(h) + ':' + pad(m) + ':' + pad(s);
      } else {
        display.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
      }
    }

    tick();
    setInterval(tick, 1000);
  });
}

/* === PRODUCT DROP TIMER === */
function initProductDropTimer() {
  var el = document.querySelector('[data-product-drop]');
  if (!el) return;

  var target = new Date(el.getAttribute('data-drop-target')).getTime();
  var daysEl = el.querySelector('[data-drop-days]');
  var hoursEl = el.querySelector('[data-drop-hours]');
  var minsEl = el.querySelector('[data-drop-mins]');
  var secsEl = el.querySelector('[data-drop-secs]');
  var atcBtn = document.querySelector('[data-drop-atc]');
  var qtySelector = el.closest('.product-info') ? el.closest('.product-info').querySelector('.quantity-selector') : null;

  function pad(n) { return n < 10 ? '0' + n : n; }

  function unlock() {
    el.style.display = 'none';
    if (atcBtn) {
      atcBtn.style.display = '';
      atcBtn.disabled = false;
    }
    if (qtySelector) qtySelector.style.display = '';
    // Re-enable sticky ATC bar
    var stickyBar = document.getElementById('stickyATC');
    if (stickyBar) {
      stickyBar.style.display = '';
      initStickyATC();
    }
  }

  function tick() {
    var now = Date.now();
    var diff = target - now;
    if (diff <= 0) {
      unlock();
      return;
    }
    var d = Math.floor(diff / 86400000);
    var h = Math.floor((diff % 86400000) / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    if (daysEl) daysEl.textContent = pad(d);
    if (hoursEl) hoursEl.textContent = pad(h);
    if (minsEl) minsEl.textContent = pad(m);
    if (secsEl) secsEl.textContent = pad(s);
  }

  tick();
  setInterval(tick, 1000);
}
